const awsConfig = {
  baseUrl: "https://04vdqd7751.execute-api.ca-central-1.amazonaws.com/dev/",
  client_id: "7ql1l33omgml5lqc6nalf4h33a",
  response_type: "code",
  redirect_uri: "https://chameye.erain.ca",
  redirectSignout_uri: "https://chameye.erain.ca",
  authority: "chameye.auth.ca-central-1.amazoncognito.com",
  scope: "aws.cognito.signin.user.admin email openid phone profile",
};
export default awsConfig;
